import React from "react";
import { useTheme, LIGHT_LOGO } from "../lib/theme";

// The Rosterly splash logo with its fade-in/out pulse — used for EVERY loading state.
export const LogoPulse = ({ className = "h-4 w-4" }) => {
    const light = useTheme() === "light";
    return (
        <img src={`${process.env.PUBLIC_URL || ""}${light ? LIGHT_LOGO : "/apple-touch-icon.png?v=3"}`} alt="" aria-hidden data-testid="logo-loader"
            className={`${className} inline-block shrink-0 rounded-[22%] object-contain`} style={{ animation: "rosterlyPulse 1.4s ease-in-out infinite" }} />
    );
};

export const Loader = ({ label = "Loading…" }) => (
    <div className="flex items-center justify-center py-16" data-testid="loader">
        <div className="flex flex-col items-center gap-3">
            <LogoPulse className="h-14 w-14" />
            <p className="text-xs uppercase tracking-wider text-[#64748B]">{label}</p>
        </div>
    </div>
);

export const SectionHeading = ({ kicker, title, action, subtitle }) => (
    <div className="flex items-end justify-between mb-4 gap-4 flex-wrap">
        <div>
            {kicker && (
                <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#9D4CDD] mb-1">
                    {kicker}
                </p>
            )}
            <h2 className="font-heading text-3xl sm:text-4xl tracking-normal uppercase font-black">
                {title}
            </h2>
            {subtitle && (
                <div className="mt-1 text-sm text-[#94A3B8]">{subtitle}</div>
            )}
        </div>
        {action && <div>{action}</div>}
    </div>
);

export default Loader;
